module.exports = __webpack_public_path__ + "static/media/A20.5475d91e.png";